import { useEffect, useRef } from "react";
import WithModal from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import { IUploadMinerPhotoModalProps } from "./UploadMinerPhotoModal.props";
import styles from "./UploadMinerPhotoModal.module.scss";
import Title from "@components/global/new/Title/Title";
import { useUploadMinerPhotoModalControl } from "./useUploadMinerPhotoModalControl";
import Uploader from "./Uploader/Uploader";

function UploadMinerPhotoModal({ ...props }: IUploadMinerPhotoModalProps) {
  if (!props.photos) return null;
  const control = useUploadMinerPhotoModalControl(props);

  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current && ref.current.parentElement) {
      ref.current.parentElement.style.width = "590px";
    }
  }, [ref]);
  return (
    <div className={styles.wrapper} ref={ref}>
      <Title>{props.formatMessage({ id: "modal.upload_photo.title" })}</Title>

      <Uploader
        id={props.minerId}
        photos={props.photos}
        onSavePhotos={props.onSavePhotos}
      />
    </div>
  );
}

export default WithModal(
  MODALS_ENUM.UPLOAD_MINER_PHOTO_MODAL,
  UploadMinerPhotoModal
);
